<template>
    <b-container>
        <b-row>
            <b-col cols="12" class="text-center">
                <b-alert variant="warning" show>
                    <span class="text-uppercase">IMPORTANTE:</span><br/>
                    proseguendo con la scelta del moto di pagamento non sarà più possibile
                    modificare la richiesta, sia in termini numerici che di nominativi.
                </b-alert>
            </b-col>
        </b-row>
        <hr>
        <b-row>
            <b-col cols="12">
                <h4 class="text-primary">Pagamento tramite bonifico bancario</h4>
            </b-col>
            <b-col cols="6" class="border-left">
                Dopo aver effettuato il bonifico alle seguenti coordinate:<br/>
                F.C. INTERNAZIONALE MILANO S.p.A.<br/>INTESA SAN PAOLO<br/>
                IBAN: IT58U0306909526100000005804<br/>
                SWIFT: BCITITMM<br/>
                CAUSALE: <strong style="color:#a29161;">Inter-XXX - nome società</strong><br/>
                Totale: XXX<br/><br/>
                Puoi inviarci la distinta del bonifico tramite il box qui di fianco
            </b-col>
            <b-col cols="6" class="UploadImportFile">
                <vue-dropzone
                    ref="uploadWireTransfer"
                    id="uploadWireTransfer"
                    :useCustomSlot="true"
                    :options="dropzoneOptions"
                    v-on:vdropzone-success="uploaded"
                    v-on:vdropzone-error="handleError"
                >
                    <div class="UploadImportFile-dropZone">
                        <h3 class="UploadImportFile-title">
                            Drag and drop per caricare la distinta
                        </h3>
                        <div class="UploadImportFile-subtitle">
                            ...o clicca per selezionare un file dal tuo computer<br/>
                            sono accettati solo file in formato pdf
                        </div>
                    </div>
                </vue-dropzone>
            </b-col>
            <b-col cols="12">
                <inter-button class="mx-auto mt-3"
                              label="Invia la distinta di bonifico"
                              :confirm="true"
                              @onClick="processUploadWireTransfer"
                />
            </b-col>
        </b-row>
        <hr>
        <b-row>
            <b-col cols="12">
                <h4 class="text-primary">Pagamento tramite carta di credito</h4>
                Cliccando sul bottone sottostante, verrai reindirizzato al sito per il pagamento tramite carta di
                credito.

            </b-col>
            <b-col cols="12">
                <inter-button class="mx-auto mt-3"
                              label="Procedi al pagamento con carta di credito"
                              :confirm="true"
                              @onClick="payingRequest"
                />
            </b-col>
        </b-row>
    </b-container>

</template>

<script>

import vueDropzone from "vue2-dropzone";
import InterButton from "@/components/form/inter-button/InterButton.vue";
import MatchRequest from "@/models/MatchRequest";
import {mapActions, mapGetters} from "vuex";

export default {
    name: "SocietyMatchesRequestPayment",
    components: {InterButton, vueDropzone},
    props: {
        matchRequest: {
            type: Object,
            default: () => Object.assign({}, MatchRequest)
        },
    },
    data() {
        return {
            file: {},
            response: {}
        }
    },
    computed: {
        ...mapGetters(['accessToken']),
        dropzoneOptions: function () {
            return {
                url: process.env.VUE_APP_API_URL + '/api/v1/requests/' + this.matchRequest.id + '/upload-wire-transfer',
                headers: {
                    "client": process.env.VUE_APP_OAUTH_CLIENT_NAME,
                    "Authorization": 'Bearer ' + this.accessToken
                },
                renameFile: "wire-transfer",
                acceptedFiles: "application/pdf",
                createImageThumbnails: false,
                autoProcessQueue: false
            }
        },
    },
    methods: {

        ...mapActions({
            societyMatchesShowRequest: 'societyMatchesShowRequest',
            societyMatchesGetPaymentUrl: 'societyMatchesGetPaymentUrl'
        }),

        processUploadWireTransfer: async function () {

            this.$refs.uploadWireTransfer.processQueue();
        },

        uploaded: async function (file, response) {
            this.file = file;
            this.response = response;
            await this.societyMatchesShowRequest(this.matchRequest);
            this.$emit('onUploaded', true)

        },
        handleError: function () {
            this.$refs.uploadWireTransfer.removeAllFiles();
            this.response = {};
            this.file = {};
            this.$bvToast.toast('File non caricato correttamente', {
                title: 'Alert',
                variant: 'warning'
            });
        },

        payingRequest: function () {

            this.societyMatchesGetPaymentUrl(this.matchRequest)
                .then((data) => {
                    window.location = data.url;
                })
                .catch(() => {
                    this.$bvToast.toast('Problemi nella generazione del link per il pagamento', {
                        title: 'Alert',
                        variant: 'warning'
                    });
                })
        },

    }
}
</script>

<style scoped>

</style>
